export const AtlassianAnalyticsMarkInverse = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5001 40H10.5001V30H14.5001V40Z"
      fill="url(#paint0_linear_1052_9255)"
    />
    <path
      d="M30.5001 40H26.5001V27H30.5001V40Z"
      fill="url(#paint1_linear_1052_9255)"
    />
    <path
      d="M22.4901 40H18.4901V22H22.4901V40Z"
      fill="url(#paint2_linear_1052_9255)"
    />
    <path
      d="M38.4901 40H34.4901V20H38.4901V40Z"
      fill="url(#paint3_linear_1052_9255)"
    />
    <path
      d="M8.91008 25.4098L6.08008 22.5798L16.2101 12.4498C17.9901 10.6698 20.8201 10.4898 22.8201 12.0398L27.2901 15.5198C27.8901 15.9798 28.7401 15.9298 29.2701 15.3998L39.0901 5.58984L41.9201 8.41984L31.7901 18.5498C30.0101 20.3298 27.1801 20.5098 25.1801 18.9598L20.7101 15.4798C20.1101 15.0198 19.2601 15.0698 18.7301 15.5998L8.91008 25.4098Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1052_9255"
        x1="12.5001"
        y1="30"
        x2="12.5001"
        y2="40"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.1" stopColor="white" stopOpacity="0.4" />
        <stop offset="0.92" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1052_9255"
        x1="28.5001"
        y1="40"
        x2="28.5001"
        y2="27"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1052_9255"
        x1="20.4901"
        y1="40"
        x2="20.4901"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1052_9255"
        x1="36.4901"
        y1="39.5"
        x2="36.4901"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.835951" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
    </defs>
  </svg>
);
